export default "__VITE_ASSET__Cv3u6Zks__"